export default __webpack_public_path__ + "images/599fa1ff61a9ff95fcac6e92c79dfa51.svg";